import { defineAsyncComponent } from 'vue';
import { FilterComponentNames, registerFilterComponent } from '#layers/ui/public';

export function registerFilterComponents(): void {
	registerFilterComponent(FilterComponentNames.UserPicker, defineAsyncComponent(() => import('./components/User/UserPicker.vue')));
	registerFilterComponent(FilterComponentNames.UserPreview, defineAsyncComponent(() => import('./components/User/UserPreview.vue')));
}
